import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Row, Col } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { createRequestActions } from './../../../store/external/request-reducer/create-request.reducer';
import { fileAttachmentActions } from './../../../store/external/common-reducer/file-attachment.reducer';
import Translation from '../../common/translation/translation.component';
import Icons from "../../icon";
import "./file-attachment.component.css";
import 'react-toastify/dist/ReactToastify.css';

class FileAttachment extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedFile: null,
            files: [],
            attaching: false
        };
    }
   

    onclickAttacheFile = () => {
        var inputFile = document.getElementById("request-attach-file");

        this.setState({ attaching: true })
        inputFile.click();

        document.body.onfocus = this.fileFocus;
    };

    onFileChange = (e) => {
        var files = e.target.files;
        var acceptedFiles = ['.pdf', '.msg', 'docx', '.xls', 'xlsx', '.txt'];

        this.setState({ attaching: false });

        let attachFiles = this.props.fileAttachment.files;
        var fileCount = (files.length + attachFiles.length);

        if (fileCount > 3) {
            toast.error('You can only upload a maximum of 3 files.', this.getToastSettings());
        } else {
            for (var i = 0; i < files.length; i++) {
                var fileType = files[i].name.substr(files[i].name.length - 4);
                if (!acceptedFiles.includes(fileType.toLowerCase())) {
                    toast.error('Unsupported file format.', this.getToastSettings());
                }
                else if (files[i].size > 10 * 1024 * 1024) {
                    toast.error('Attachment size exceeds the allowable limit of 10 MB.', this.getToastSettings());
                } else {
                    attachFiles.push(files[i]);
                }
            }

            this.props.updateAttachFile(attachFiles);
        }
    };

    getToastSettings = () => {
        return {
            position: "top-center",
            theme: "colored",
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        };
    }

    removeFileByName = (name) => {
        //const { updateOrderAmmendFileNames, orderFile, orderAmmendFileNames, addOrderFile, isDisabled } = this.props;

        //if (uploadingAPFile || isDisabled)
        //return;

        const { files } = this.props.fileAttachment;

        var newAttachFile = files.filter(function (obj) {
            return obj.name !== name;
        });
        //if (orderAmmendFileNames != undefined) {
        //    var oldFileNames = orderAmmendFileNames.filter(function (n) {
        //        return n !== name;
        //    });
        //    updateOrderAmmendFileNames(oldFileNames);
        //}
        var inputFile = document.getElementById("request-attach-file");
        inputFile.value = "";

        this.props.updateAttachFile(newAttachFile);
    }

    displayAttachment = (files) => {
        //const { orderAmmendFileNames } = this.props;
        if (files && files.length > 0) {
            return files.map((x, i) => {
                return (
                    <Row key={i}>
                        <div>
                            <div className="file-display">
                                <span data-dz-name>{x.name}</span>
                                <Icons
                                    name="x-solid"
                                    size="15px"
                                    customClassName="icon-right"
                                    onClick={(e) => this.removeFileByName(x.name)}
                                />
                            </div>
                        </div>
                    </Row>
                )
            })
        }
        //if (orderAmmendFileNames && orderAmmendFileNames.length > 0) {
        //    return orderAmmendFileNames.map((x, i) => {
        //        return (
        //            <Row key={i}>
        //                <div>
        //                    <div>
        //                        <span onClick={(e) => this.removeFileByName(x)} data-dz-remove></span>
        //                    </div>
        //                    <div><span data-dz-name>{x}</span></div>
        //                </div>
        //            </Row>
        //        )
        //    })
        //}
    };

    render() {
        const { files, disableAttchBtn } = this.props.fileAttachment;
        const { isUnmounted } = this.props;
        return (
            <div>
                {isUnmounted ? this.onRemoveData() : null}
                <Row>
                    <Col>
                        <button disabled={disableAttchBtn} type="button" className="btn file-attach-button" onClick={(e) => this.onclickAttacheFile()}>
                            <span><Translation translationKey="file_attachment" /></span>
                        </button>
                        <input hidden={true} id="request-attach-file" multiple type="file" className="a-f-hide" onChange={(e) => this.onFileChange(e)} accept=".pdf,.msg,.docx,.xls,.xlsx,.txt" />
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} md={12}>
                        {this.displayAttachment(files)}
                    </Col>
                </Row>
            </div>
        );
    }
}

export default connect(
    state => {
        const { createRequest, fileAttachment } = state;
        return {
            fileAttachment
            , createRequest
        };
    }
    , dispatch =>
        bindActionCreators(
            Object.assign({}, createRequestActions
                , fileAttachmentActions),
            dispatch
        )
)(FileAttachment);